import ComponentWithSocket from '../../lib/component'
import { Component } from 'vue-property-decorator';

import * as Store from '../../store';

import template from './auction-manage.vue';
import moment from 'moment';

import WebsocketClient, { WebsocketsListener } from '../../utils/ws';

@Component({
    mixins: [template]
})

export default class ManageAuction extends ComponentWithSocket {

    private data: {
        id: string,
        addUserError: string,
        addUserOpen: boolean,
        qrUserOpen: boolean,
        qrUserId: string,
        auction: any,
        lots: any[],
        auctionUsers: any[],
        auctionWinners: any[],
        newNotification: any
    } = {
            id: '',
            addUserError: '',
            addUserOpen: false,
            qrUserOpen: false,
            qrUserId: '',
            auction: undefined,
            auctionUsers: [],
            auctionWinners: [],
            lots: [],
            newNotification: {}
        };

    private addUser: {
        firstName: string
        lastName: string
        email: string
        phone: string
        paddle: number
    } = {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            paddle: 0
        }

    private sellLot: {
        lot: any,
        auctionUser: any,
        price: number
    } = {
            lot: undefined,
            auctionUser: undefined,
            price: 0
        }

    selectedCurrency: string = 'EUR'
    activeTabIndex: number = 0

    constructor() {

        super();

        this.wsListener.onGet('auctions', (success: boolean, data: any) => {

            Store.commitLoaderVisibility(this.$store, false);

            if (success) {
                this.data.auction = data;
            }

        });

        this.wsListener.onGet('admin.lots', (success: boolean, data: any) => {
            if (success) {
                this.data.lots = data;
            }
        });

        this.wsListener.onGet('admin.auctions.users', (success: boolean, data: any) => {
            if (success) {
                this.data.auctionUsers = data;
            }
        });

        this.wsListener.onGet('admin.auctions.winners', (success: boolean, data: any) => {
            if (success) {
                this.data.auctionWinners = data;
            }
        });

        this.wsListener.onPost('admin.auctions.users', (success: boolean, data: any) => {
            if (success) {
                this.data.addUserError = ''
                this.data.addUserOpen = false
                this.addUser = {
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    paddle: 0
                }
                this.wsListener.sendGet('admin.auctions.users', {
                    auction: this.data.id
                })
            }
            else {
                this.data.addUserError = data
            }
        });

        this.wsListener.onPost('auctions.setup', (success: boolean, data: any) => {
            if (success) {
                this.data.auction.status = 1;
            } else {
                this.data.auction.status = 3;
            }
        });

        this.wsListener.onPost('auctions.setup.lots', (success: boolean, data: any) => {
            this.data.lots.unshift(data.log);
            this.data.auction = data.auction;
        });

        this.wsListener.onPut('admin.auctions', (success: boolean, data: any) => {
            if (success) {
                alert('Licitatia a fost actualizata')
            } else {
                alert(data)
            }
        });

        this.wsListener.onPost('admin.auctions.sync', (success: boolean, data: any) => {
            if (success) {
                this.data.auction.syncInProgress = true
            } else {
                alert(data)
            }
        });

        this.wsListener.onPost('admin.auctions.notification.new', (success: boolean, data: any) => {

            Store.commitLoaderVisibility(this.$store, false);

            if (success) {

                this.data.newNotification = {}

                alert('Notificarea a fost trimisa cu success')

            } else {
                alert(data)
            }
        });

        this.wsListener.onPost('admin.auctions.lots.sell', (success: boolean, data: any) => {

            Store.commitLoaderVisibility(this.$store, false);

            if (success) {

                this.sellLot.lot = undefined
                this.sellLot.auctionUser = undefined
                this.sellLot.price = 0

                this.wsListener.sendGet('admin.lots', {
                    auction: this.data.id
                });

            } else {
                alert(data)
            }
        });

        this.wsListener.onPost('admin.auctions.sync.progress', (success: boolean, data: any) => {
            if (success) {
                this.data.auction.syncInProgress = data.syncInProgress
                this.data.auction.syncProgress = data.syncProgress
            }
        });

        this.wsListener.onPost('admin.auctions.winners.hide', (success: boolean, data: any) => {
            if (success) {
                this.wsListener.sendGet('admin.auctions.winners', {
                    auction: this.data.id
                });
            }
        });
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from)
        next()
    }

    mounted() {

        this.data.id = this.$root.$route.params.id;

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('auctions', {
            _id: this.data.id
        });

        this.wsListener.sendGet('admin.lots', {
            auction: this.data.id
        });

        this.wsListener.sendGet('admin.auctions.users', {
            auction: this.data.id
        });

        if (this.hasReportsAccess) {
            this.wsListener.sendGet('admin.auctions.winners', {
                auction: this.data.id
            });
        }

    }

    goLive() {

        this.wsListener.sendPost('auctions.setup', {
            _id: this.data.auction._id
        });

    }

    beautifyDateTime(dtt: any) {
        return moment(dtt).format('llll');
    }

    timeAgo(dtt: any) {
        return moment(dtt).fromNow();
    }

    updateLotsOrder() {

        let lotsOrder: any = {};

        for (let lotIndex in this.data.lots) {
            lotsOrder[this.data.lots[lotIndex].lot._id] = parseInt(lotIndex) + 1;
        }

        this.wsListener.sendPost('admin.lots.ordering', {
            auction: this.data.auction._id,
            lotsOrder: lotsOrder
        });

    }

    updateAuctionSettings() {
        this.wsListener.sendPut('admin.auctions', {
            ...this.data.auction
        });
    }

    sendAuctionNotification() {

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('admin.auctions.notification.new', {
            _id: this.data.auction._id,
            title: this.data.newNotification.title,
            content: this.data.newNotification.content,
            base64Image: this.data.newNotification.base64Image
        });

    }

    doAuctionSync() {
        this.wsListener.sendPost('admin.auctions.sync', {
            auction: this.data.auction._id,
            processImages: true
        });
    }

    addAuctionUser() {
        this.wsListener.sendPost('admin.auctions.users', {
            auction: this.data.auction._id,
            user: this.addUser
        })
    }

    doSellLot() {

        if (!this.sellLot.lot || !this.sellLot.auctionUser || !this.sellLot.price) {
            alert('Te rugam sa completezi toate datele din formular')
            return
        }

        if (!confirm(`Esti sigur ca vrei sa vinzi lotul ${this.sellLot.lot.name} utilizatorului ${this.sellLot.auctionUser.firstName} ${this.sellLot.auctionUser.lastName} pentru suma de ${this.sellLot.price} ? `)) {
            return
        }

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('admin.auctions.lots.sell', {
            auction: this.data.auction._id,
            lot: this.sellLot.lot._id,
            auctionUser: this.sellLot.auctionUser._id,
            price: this.sellLot.price
        })

    }

    qrUserOpen(user: any) {
        this.data.qrUserOpen = true
        this.data.qrUserId = user._id
    }

    get hasReportsAccess() {
        let user = Store.readLoggedInUser(this.$store);
        return user && user.hasReportsAccess
    }

    get comissionPercent() {
        return this.data.auction ? this.data.auction.comission : 0
    }

    get currencySymbol() {
        if (this.selectedCurrency == 'EUR') return '€'
        return 'Lei'
    }

    getComissionAmount(amount: number) {
        return amount * (this.comissionPercent / 100)
    }

    getTotalPriceAmount(amount: number) {
        return amount + this.getComissionAmount(amount)
    }

    formatPrice(amount: number) {
        if (this.selectedCurrency == 'EUR') return amount
        return amount * this.data.auction.euroRate
    }

    onNotificationBannerChange(e: any) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
        this.createImage(files[0]);
    }

    createImage(file: any) {
        let reader = new FileReader();
        let vm = this;
        reader.onload = (e: any) => {
            vm.data.newNotification.base64Image = e.target.result;
        };
        reader.readAsDataURL(file);
    }

    doHideWinner(winner: any) {
        if (
            !confirm(
                `Esti sigur ca vrei sa ascunzi castigatorul ` +
                `${winner.user.firstName || winner.auctionUser.firstName} ` +
                `${winner.user.lastName || winner.auctionUser.lastName}?`
            )
        ) {
            return
        }
        this.wsListener.sendPost('admin.auctions.winners.hide', {
            auctionUser: winner.auctionUser._id
        })

        // Manually remove the winner from the list
        const index = this.data.auctionWinners.indexOf(winner)
        if (index > -1) {
            this.data.auctionWinners.splice(index, 1)
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/auction-manage/index.ts